import request from "../../request";

export let getFullNews = async id => {
  let news = await request(
    {},
    `/api/lajm/GetLajmByID/${id}?$expand=foto($select=FullPath,Kryesore)&$expand=dokLajme($select=Emri,FullPath)`,
    "index"
  );
  return news;
};
export let getHomeNews = async () => {
  // kthe 3 te fundit
  let newsArray = await request(
    {},
    `/api/lajm/GetAllLajmet?$orderby=id desc&$top=3&$filter=Publikuar eq true&$expand=struktura($select=emri)`,
    "index"
  );
  return newsArray;
};

export let AllNews = async page => {
  // kthe te gjitha lajmet
  let newsArray = await request(
    {},
    `/api/lajm/GetAllLajmet?$orderby=id desc&$top=${page * 15 +
      15}&$filter=Publikuar eq true&$expand=struktura($select=emri)`,
    "index"
  );
  return newsArray;
};
export let AllNewsByStructureId = async (page, id) => {
  // kthe te gjitha lajmet
  let newsArray = await request(
    {},
    `/api/lajm/GetLajmetByStrukturaID/${id}?$orderby=id desc&$top=${page * 15 +
      15}&$filter=Publikuar eq true&$expand=struktura($select=emri)`,
    "index"
  );
  return newsArray;
};
export let getStrukturat = async () => {
  let strukturat = await request(
    {},
    `/api/struktura/GetAllStrukturat`,
    "index"
  );
  return strukturat;
};
